import seoTopicClustersData from "./seoTopicClusters.json";
import { ratgeberArticles } from "./ratgeberArticles";

export const seoTopicClusters = seoTopicClustersData;

const articleBySlug = new Map(ratgeberArticles.map((article) => [article.slug, article]));

export const getTopicClusterByServiceAnchor = (serviceAnchor) =>
  seoTopicClusters.find((cluster) => cluster.serviceAnchor === serviceAnchor);

export const getTopicClusterBySchemaServiceId = (schemaServiceId) =>
  seoTopicClusters.find((cluster) => cluster.schemaServiceId === schemaServiceId);

export const getRatgeberLinksForService = (serviceAnchor, limit = 4) => {
  const cluster = getTopicClusterByServiceAnchor(serviceAnchor);

  if (!cluster) return [];

  return cluster.articleSlugs
    .map((slug) => articleBySlug.get(slug))
    .filter(Boolean)
    .slice(0, limit);
};

export const getServiceLinksForArticle = (articleSlug) =>
  seoTopicClusters
    .filter((cluster) => cluster.articleSlugs.includes(articleSlug))
    .map((cluster) => ({
      id: cluster.id,
      title: cluster.serviceTitle,
      path: cluster.servicePath,
      leadKeyword: cluster.leadKeyword,
    }));
